var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"},attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":_vm.includeList}},[_c('router-view',{key:_vm.key,staticClass:"Router"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }